
    import React from 'react';
    import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "icon-more-vertical-24_YyhnW",
  "use": "icon-more-vertical-24_YyhnW-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-more-vertical-24_YyhnW\">\n<g transform=\"translate(10 4)\">\n<path d=\"M2 12C3.1 12 4 12.9 4 14C4 15.1 3.1 16 2 16C0.9 16 0 15.1 0 14C0 12.9 0.9 12 2 12ZM2 10C0.9 10 0 9.1 0 8C0 6.9 0.9 6 2 6C3.1 6 4 6.9 4 8C4 9.1 3.1 10 2 10ZM2 4C0.9 4 0 3.1 0 2C0 0.9 0.9 0 2 0C3.1 0 4 0.9 4 2C4 3.1 3.1 4 2 4Z\" />\n</g>\n</symbol>"
});
    sprite.add(symbol);

    const IconMoreVertical_24YyhnWSpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "icon-more-vertical-24_YyhnW", width: 24, height: 24, ...props })
    }

    export { IconMoreVertical_24YyhnWSpriteSymbolComponent as ReactComponent };
  